// extracted by mini-css-extract-plugin
var _1 = "Hsur4";
var _2 = "RIs0m";
var _3 = "OhZaU";
var _4 = "WM1YG";
export { _1 as "handle", _2 as "resizer", _3 as "theme-dark", _4 as "theme-light" }
